/* eslint-disable no-negated-condition */
(function() {

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.cstm-qty-input-add').forEach((add) => {
      add.addEventListener('click', (e) => {
        e.preventDefault();
        const input = add.parentElement.querySelector('input');
        input.value = Number(input.value) + 1;

        document.querySelector('#cstm-sub-submit').click();
      });
    });
    document.querySelectorAll('.cstm-qty-input-remove').forEach((remove) => {
      remove.addEventListener('click', (e) => {
        e.preventDefault();
        const input = remove.parentElement.querySelector('input');
        input.value = Number(input.value) - 1;
        document.querySelector('#cstm-sub-submit').click();
      });
    });

    if (document.querySelector('#donation')) {
      document.querySelector('#donation').addEventListener('click', (e) => {
        e.preventDefault();
        const donation = document.querySelector('.cstm-donations-row');
        if (donation.style.display !== 'none') {
                    // e.currentTarget.textContent = 'donation -'
          donation.style.display = 'none';
        } else {
          e.currentTarget.style.display = 'none';
                    // e.currentTarget.textContent = 'donation x'
          donation.style.display = 'block';
        }
      });
    }
  }); /* End of DOMContentLoaded */

  
  $(function () {

        const addError = function (line) {
            if ($('.cart-error-message').length !== 0) {
                return false;
            }
            const $wrapper = $('.shipping_calculator').eq(1);
            const $h1 = document.createElement('h4');

            $h1.style.color = 'red';
            $h1.style.textAlign = 'center';
            $h1.classList.add('cart-error-message');
            console.warn('ADD ERROR TO', $wrapper, $h1);
            $h1.innerHTML =
                'One or more of the items in your cart are no longer available and will be removed';
            $($h1).insertBefore($wrapper);
        };

        const removeByLine = function (line) {
            jQuery.post('/cart/change.js', {
                line: line,
                quantity: 0
            });
            addError(line);
        };

        const sourceCheck = function (CART) {
            const preOrderItems = CART.filter(item => {
                return  item.full_item.properties && item.full_item.properties['This item is on'] !== undefined;
            });

            for (let _i = 0; _i < preOrderItems.length; _i++) {
                let item = preOrderItems[_i];
                let {
                    variant_id,
                    variants,
                    tags,
                    variant_title,
                    line
                } = item;
                const liveVariant = variants.filter(v => v.id == variant_id);
                const relTags = tags.map(t => t.toLowerCase()).filter(t => t.indexOf(liveVariant[0].option1
                    .toLowerCase()) !== -1);
                const preorderTag = relTags[0];
                const preorderLimit = parseInt(preorderTag.split('limit:')[1]) * -1;
                const {
                    inventory_quantity
                } = liveVariant[0]


                console.log(inventory_quantity <= preorderLimit, line, item);
                if (inventory_quantity <= preorderLimit) {
                    removeByLine(line + 1);
                }
            }

        };



        const pullCartData = $.ajax({
            type: 'GET',
            url: '/cart?view=check_preorder',
            success: function (r) {
                const cart = JSON.parse(r);
                console.warn('success', cart);
                sourceCheck(cart);
            }
        });

        const updateAttributes = function () {
            const params = {
                type: 'POST', 
                url: '/cart/update.js',
                data: 'attributes[Custom Gift Box]=No',
                dataType: 'json',
                success: function(cart){
                    
                }
            }

            $.ajax(params);
        };
    
    const instantRemoveCB = function(){
            const params = {
                type: 'GET', 
                url: '/cart',
                success: function(html){
                    const $html = $(html);
                    const subtotal = $(html).find('.cstm-subtotal-row').html();

                    document.querySelector('.cstm-subtotal-row').innerHTML = subtotal;
                }
            }
            $.ajax(params);
    };

        const removeGiftBox = function(line, cb) {
            const cart = JSON.parse(document.getElementById('cart-data').innerHTML);
            const giftProduct = JSON.parse(document.getElementById('gift-box').innerHTML);
            const inCartIDs = cart.items.map((item) => item.product_id);
            const boxInCart = inCartIDs.indexOf(giftProduct.id) + 1;


            const params = {
                type: 'POST', 
                url: '/cart/change.js',
                data: 'quantity=' + 0 + '&line=' +  line,
                dataType: 'json',
                success: function(cart){

                    if(cb) {
                        cb();
                    } else {
                        window.location.reload();
                    }
                    return;
                    const row = $(`.cstm-item-row#row-${giftProduct.variants[0].id}`);
                    console.log('Remove Row?', row, giftProduct);

                    row.remove();
                    updateAttributes();
                    instantRemoveCB();
                }
            }

            $.ajax(params);
        };

        const instantAddCB = function(item) {
            const params = {
                type: 'GET', 
                url: '/cart',
                success: function(html){
                    const $html = $(html);
                    const rows = $html.find(`.cstm-item-row`);
                    const row = $html.find(`.cstm-item-row#row-${item.id}`);
                    const newCart = $html.find('#cart-data');
                    const oldCart = document.getElementById('cart-data');
                    const boxToggleConatiner = document.querySelector('.gift-box-wrapper');
                    const subtotal = $(html).find('.cstm-subtotal-row').html();
                
                console.warn('SUbtotal Row', subtotal);
                

                    boxToggleConatiner.classList.remove('loading');

                    oldCart.innerHTML = newCart.text();
                    row.insertAfter($('.cstm-item-row').last());
                    document.querySelector('.cstm-subtotal-row').innerHTML = subtotal;
                    console.log('Rows?', rows, row);
                }
            }
            console.log('Instant Add CB', item, item.id);

            $.ajax(params);
        };

        const instantAddGiftBox = function() {
            const giftProduct = JSON.parse(document.getElementById('gift-box').innerHTML);
            const boxToggleConatiner = document.querySelector('.gift-box-wrapper');

            boxToggleConatiner.classList.add('loading');
            addAttributes(function(){
                addGiftBox(giftProduct, instantAddCB);
            }); 
        };

        const giftChangeHandler = function(event) {
            const checked = event.target.checked;
            const ecoFriendly = document.getElementById('eco-friendly-packaging');
            const cart = JSON.parse(document.getElementById('cart-data').innerHTML);
            const giftProduct = JSON.parse(document.getElementById('gift-box').innerHTML);
            const inCartIDs = cart.items.map((item) => item.product_id);
            const boxInCart = inCartIDs.indexOf(giftProduct.id);

            if (checked) {
                ecoFriendly.checked = false;
                instantAddGiftBox();
            } else {
                console.log('Remove?', boxInCart, cart);
                if (boxInCart !== -1) {
                    removeGiftBox();
                }
            }
        };

        const ecoChangeHandler = function(event) {
            const giftBoxControl = document.getElementById('custom-gift-box');

            if (event.target.checked) {
                giftBoxControl.checked = false;
                $('#custom-gift-box').trigger('change');
            }
            console.log('Eco Change Handler', event.target, event.target.checked);
        }; 

        const addAttributes = function (cb) {
            const params = {
                type: 'POST', 
                url: '/cart/update.js',
                data: 'attributes[Custom Gift Box]=Yes&attributes[Eco-Friendly Packaging]=No',
                dataType: 'json',
                success: function(cart){
                    if (!cb) {
                        window.location = '/checkout';
                    } else { cb() }                    
                }
            }

            $.ajax(params);
        };

        const finalSubmitForm = function () {
            document.getElementById('checkout-form').classList.add('gifted');
            addAttributes();
            
        };

        const addGiftBox = function(giftProduct, callback) {
            const params = { 
                type: 'POST',
                url: '/cart/add.js',
                data: giftProduct,
                dataType: 'json',
                success: function(cart) {
                    console.log('Gift Box Added', cart);
                    callback(cart);
                }
            }

            $.ajax(params);
        };

        const giftFormDecisionHandler = function() {
            const cart = JSON.parse(document.getElementById('cart-data').innerHTML);
            const giftProduct = JSON.parse(document.getElementById('gift-box').innerHTML);
            const inCartIDs = cart.items.map((item) => item.product_id);
            const boxInCart = inCartIDs.indexOf(giftProduct.id);

            if (boxInCart === -1) {
                return addGiftBox(giftProduct, finalSubmitForm);
            }

            finalSubmitForm();
        };

        const checkoutSubmit = function(event) {
            const customGiftBox = document.getElementById('custom-gift-box');
            const giftBoxChecked = customGiftBox.checked;

            console.log('SUBMITTing');
            if (giftBoxChecked && !event.target.classList.contains('gifted') ) {
                console.warn('Checkout submit Stopped');
                event.preventDefault();  
                giftFormDecisionHandler();
            }
        };
    
    $(document).on('click', '.box-remover', function(event) {
        event.preventDefault();
        
        document.getElementById('custom-gift-box').checked = false;
        
        $('#custom-gift-body').trigger('change');
        removeGiftBox();
        
        console.warn('Remove Box From REMOVE Link');
    });

    if ( document.getElementById('custom-gift-box') ) {
        document.getElementById('custom-gift-box').addEventListener('change', giftChangeHandler);
        document.getElementById('eco-friendly-packaging').addEventListener('change', ecoChangeHandler);
    }

    function giftInputChangeHandler(event) {
        const cart = JSON.parse(document.getElementById('cart-data').innerHTML);
        const giftProduct = JSON.parse(document.getElementById('gift-box').innerHTML);
        const properties = {
            _mainProduct: event.target.name.split('-').reverse()[0],
            product: event.target.getAttribute('data-title'),
        };

        const add ={
            quantity: 1,
            id: giftProduct.variants[0].id,
            properties,
        };

        if (event.target.checked) {
            addGiftBox(add, function(){
                window.location.reload();
            });
        } else {
            const itemKey = event.target.name.split('-').reverse()[0];
            const giftBoxInCart = [...cart.items].map((item, index) => {
                return {
                    ...item,
                    line: index + 1,
                }
            }).find((item) => item.properties._mainProduct && item.properties._mainProduct === itemKey);

            if(giftBoxInCart) {
                removeGiftBox(giftBoxInCart.line);
            }
            console.warn('Gift In Box!', giftBoxInCart);
        }

        console.log('Input changed', event.target.checked);
    }

    function checkCartState(cart) {
        const giftProduct = JSON.parse(document.getElementById('gift-box').innerHTML);
        const giftItems = cart.items.map((item, index) => {
            return {
                ...item,
                line: index + 1,
            }
        }).filter((item) => {
            return item.handle == giftProduct.handle;
        });

        function removeClickHandler(event) {
            event.preventDefault();
            const giftLine = event.target.dataset.giftLine;
            const originalDestination = event.target.getAttribute('href');
            const originalLine = Number(event.target.dataset.line) - 1;

            removeGiftBox(giftLine, function() {
                removeGiftBox(originalLine);
                // window.location = originalDestination;
            });

            console.log('Stop Main Removal', event.target.dataset);
        }

        [...giftItems].forEach((item) => {
            const mainKey = item.properties._mainProduct;
            const link = document.querySelector(`.cstm-rmv-input[data-key="${mainKey}"]`);

            if(!link) { 
                removeGiftBox(item.line);
                return;
            }

            link.setAttribute('data-gift-line', item.line);
            link.addEventListener('click', removeClickHandler);
        });
        console.log('Check Cart State for Unassociated Gifts', cart, giftItems);
    } 

    function startGiftWrapItems() {
        const cart = JSON.parse(document.getElementById('cart-data').innerHTML);
        console.warn('Starting Cart', cart);
        const allGiftInputs = document.querySelectorAll('input.gift-wrap-item-input');

        checkCartState(cart);

        [...allGiftInputs].forEach(function(input) {
            const inputKey = input.name.split('-').reverse()[0];
            const giftInCart = [...cart.items].find((item) => item.properties && item.properties._mainProduct && item.properties._mainProduct === inputKey);

            console.log('Gift In Cart', giftInCart);

            if (giftInCart) {input.checked = true;}
            

            input.addEventListener('change', giftInputChangeHandler);
        });

    }

    startGiftWrapItems();
    
  });
})();
